import React from 'react';

type PageSubTitleProps = {
  children: React.ReactNode;
};

const PageSubTitle: React.FC<PageSubTitleProps> = ({ children }) => (
  <div className="m-auto mb-8">
    <p className="text-center text-darkgray">
      {children}
    </p>
  </div>
);

export default PageSubTitle;
